import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    // redirect: '/recharge'
    component: () => import('@/views/home/index')
  },
  // {
  //   path: '/face-bind',
  //   name: 'FaceBind',
  //   component: () => import('@/views/face-bind/face-bind')
  // },
  {
    path: '/order-login',
    name: 'Login',
    component: () => import('@/views/login/login')
  },
  {
    path: '/login-fail',
    name: 'LoginFail',
    component: () => import('@/views/loginFail/loginFail')
  },
  // {
  //     path: '/account',
  //     name: 'Account',
  //     component: () => import('@/views/account')
  // },
  // {
  //     path: '/buyProduct',
  //     name: 'BuyProduct',
  //     component: () => import('@/views/buy-product')
  // },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/recharge/index')
  },
  {
    path: '/recharge-history',
    name: 'RechargeHistory',
    component: () => import('@/views/recharge-history/index')
  },
  {
    path: '/recharge-center',
    name: 'RechargeCenter',
    component: () => import('@/views/recharge/index')
  },
  {
    path: '/consumption',
    name: 'Consumption',
    component: () => import('@/views/consumption/consumption')
  },
  {
    path: '/consumption-detail',
    name: 'ConsumptionDetail',
    component: () => import('@/views/consumption/detail')
  },
  {
    path: '/paycode',
    name: 'Paycode',
    component: () => import('@/views/paycode/paycode')
  },
  {
    path: '/notify',
    name: 'Notify',
    component: () => import('@/views/notify/notify')
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/order/order')
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: () => import('@/views/order/detail')
  },
  {
    path: '/personal',
    name: 'Personal',
    component: () => import('@/views/personal')
  },
  {
    path: '/verification',
    name: 'Verification',
    component: () => import('@/views/verification/verification')
  },
  {
    path: '/allowance',
    name: 'Allowance',
    component: () => import('@/views/allowance/index')
  },
  {
    path: '/meal-code',
    name: 'MealCode',
    component: () => import('@/views/order/meal-code')
  },
  {
    path: '/debug',
    name: 'Debug',
    component: () => import('@/views/debug/debug')
  },
  {
    path: '/access-record',
    name: 'AccessRecord',
    component: () => import('@/views/access-record/access-record')
  },
  {
    path: '/check-work',
    name: 'CheckWork',
    component: () => import('@/views/check-work/index')
  },
  {
    path: '/leave',
    name: 'Leave',
    component: () => import('@/views/leave/index')
  },
  {
    path: '/to-leave',
    name: 'ToLeave',
    component: () => import('@/views/leave/ask-leave')
  },
  {
    path: '/examine-leave',
    name: 'ExamineLeave',
    component: () => import('@/views/leave/examine-leave')
  },
  {
    path: '/smsAuth',
    name: 'SmsAuth',
    component: () => import('@/views/smsAuth/index')
  },
  {
    path: '/smsAuth/add',
    name: 'SmsAuthAdd',
    component: () => import('@/views/smsAuth/$id')
  },
  {
    path: '/personInfo',
    name: 'PersonInfo',
    component: () => import('@/views/person-info/PersonInfo')
  },
  {
    path: '/accBinding',
    name: 'AccBinding',
    component: () => import('../views/account/AccBinding.vue')
  },
  {
    path: '/accUnbundling',
    name: 'AccUnbundling',
    component: () => import('../views/account/AccUnbundling.vue')
  },
  {
    path: '/pwdSetting',
    name: 'PwdSetting',
    component: () => import('../views/pwdSetting/PwdSetting.vue')
  },
  {
    path: '/faceBinding',
    name: 'FaceBinding',
    component: () => import('@/views/face-bind/FaceBinding.vue')
  },
  {
    path: '/faceCheck',
    name: 'FaceCheck',
    component: () => import('@/views/face-bind/FaceCheck.vue')
  },
  {
    path: '/faceCheckList',
    name: 'FaceCheckList',
    component: () => import('@/views/face-bind/FaceCheckList.vue')
  },
  {
    path: '/center',
    name: 'Center',
    component: () => import('@/views/home/Center.vue')
  },
  {
    path: '/inform-add',
    name: 'InformAdd',
    component: () => import('../views/inform/inform-add.vue')
  },
  {
    path: '/inform-detail',
    name: 'InformDetail',
    component: () => import('../views/inform/inform-detail.vue')
  },
  {
    path: '/inform-list',
    name: 'InformList',
    component: () => import('../views/inform/inform-list.vue')
  },
  {
    path: '/inform-unread',
    name: 'InformUnread',
    component: () => import('../views/inform/inform-unread.vue')
  },
  {
    path: '/inform-userUnread',
    name: 'InformUserUnread',
    component: () => import('../views/inform/inform-userUnread.vue')
  },
  {
    path: '/blocked',
    name: 'Blocked',
    component: () => import('@/views/home/Blocked.vue')
  },
  {
    path: '/userWallet',
    name: 'UserWallet',
    component: () => import('@/views/user/user-wallet.vue')
  },
  {
    path: '/cash-withdrawal',
    name: 'CashWithdrawal',
    component: () => import('@/views/user/cash-withdrawal.vue')
  },
  {
    path: '/refund-detail',
    name: 'RefundDetail',
    component: () => import('@/views/user/refund-detail.vue')
  },
  {
    path: '/appCenter',
    name: 'AppCenter',
    component: () => import('@/views/all/app-center.vue')
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/setting/index.vue')
  },
  {
    path: '/pickInform',
    name: 'PickInform',
    component: () => import('@/views/pick-up/pick-inform.vue')
  },
  {
    path: '/pickUserInfo',
    name: 'PickUserInfo',
    component: () => import('@/views/pick-up/userInfo.vue')
  },
  {
    path: '/pickAddUserInfo',
    name: 'PickAddUserInfo',
    component: () => import('@/views/pick-up/addUserInfo.vue')
  },
  {
    path: '/pick-records',
    name: 'PickRecords',
    component: () => import('@/views/pick-up/pick-records.vue')
  },
  {
    path: '/upload-face',
    name: 'UploadFace',
    component: () => import('@/views/pick-up/upload-face.vue')
  },
  {
    path: '/class-inform',
    name: 'ClassInform',
    component: () => import('@/views/pick-up/class-inform.vue')
  },
  {
    path: '/receipt',
    name: 'Receipt',
    component: () => import('@/views/receipt/receipt.vue')
  },
  {
    path: '/family-list',
    name: 'FamilyList',
    component: () => import('@/views/family/family-list.vue')
  },
  {
    path: '/family-detail',
    name: 'FamilyDetail',
    component: () => import('@/views/family/family-detail.vue')
  },
  {
    path: '/family-apply-detail',
    name: 'FamilyApplyDetail',
    component: () => import('@/views/family/family-apply-detail.vue')
  },
  {
    path: '/my-report-meal',
    name: 'MyReportMeal',
    component: () => import('@/views/my-report-meal/index.vue')
  },
  {
    path: '/report-meal-apply',
    name: 'ReportMealApply',
    component: () => import('@/views/my-report-meal/apply/index.vue')
  },
  {
    path: '/cardManage',
    name: 'CardManage',
    component: () => import('@/views/cardManage/index.vue')
  },
  {
    path: '/bindingCard',
    name: 'BindingCard',
    component: () => import('@/views/cardManage/bindingCard.vue')
  },
  // 餐券
  {
    path: '/coupon',
    name: 'Coupon',
    component: () => import('@/views/coupon/coupon.vue')
  },
  {
    path: '/order-form',
    name: 'OrderForm',
    component: () => import('@/views/order/order-form'),
    meta: {
      title: '四川_众鹤_提交订单'
    }
  },
  {
    path: '/order-address',
    name: 'OrderAddress',
    component: () => import('@/views/order/address'),
    meta: {
      title: '四川_众鹤_我的收货地址'
    }
  },
  {
    path: '/order-addAddress',
    name: 'OrderAddAddress',
    component: () => import('@/views/order/add-address'),
    meta: {
      title: '四川_众鹤_添加收货地址'
    }
  },
  {
    path: '/nutrition',
    name: 'Nutrition',
    component: () => import('@/views/nutrition/nutrition.vue'),
    meta: {
      title: '四川_众鹤_营养分析'
    }
  },
  {
    path: '/health-meal',
    name: 'HealthMeal',
    component: () => import('@/views/health-meal/index.vue'),
    meta: {
      title: '四川_众鹤_健康饮食'
    }
  },
  {
    path: '/student-list',
    name: 'StudentList',
    component: () => import('@/views/health-meal/student-list/index.vue')
  },
  {
    path: '/meal-record',
    name: 'MealRecord',
    component: () => import('@/views/health-meal/meal-record/index.vue')
  },
  {
    path: '/pay-list',
    name: 'PayList',
    component: () => import('@/views/health-meal/pay-list/index.vue')
  },
  {
    path: '/pay-detail',
    name: 'PayDetail',
    component: () => import('@/views/health-meal/pay-detail/index.vue')
  },
  {
    path: '/pay-record',
    name: 'PayRecord',
    component: () => import('@/views/health-meal/pay-record/index.vue')
  },
  {
    path: '/passCode',
    name: 'PassCode',
    component: () => import('@/views/passCode/index')
  },
  {
    path: '/inviteList',
    name: 'InviteList',
    component: () => import('../views/invite/invite-list.vue')
  },
  {
    path: '/inviteAdd',
    name: 'InviteAdd',
    component: () => import('../views/invite/invite-add.vue')
  },
  {
    path: '/inviteQuery',
    name: 'InviteQuery',
    component: () => import('../views/invite/invite-query.vue')
  },
  {
    path: '/inviteDetail',
    name: 'InviteDetail',
    component: () => import('../views/invite/invite-detail.vue')
  },
  {
    path: '/inviteEdit',
    name: 'InviteEdit',
    component: () => import('../views/invite/invite-edit.vue')
  },
  {
    path: '/rechargeDetail',
    name: 'RechargeDetail',
    component: () => import('@/views/recharge-history/detail.vue')
  },
  {
    path: '/password-free-signing',
    name: 'PasswordFreeSigning',
    component: () => import('@/views/password-free-signing/index.vue')
  },
  {
    path: '/pay-result',
    name: 'PayResult',
    component: () => import('@/views/pay-result/index.vue')
  },
  {
    path: '/user-agents',
    name: 'UserAgents',
    component: () => import('@/views/user/user-agents/index.vue'),
    meta: {
      title: '四川_众鹤_用户协议',
      subTitle: '用户协议'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () =>
      import('@/views/user/user-agents/privacy-policy/index.vue'),
    meta: {
      title: '四川_众鹤_个人信息协议',
      subTitle: '个人信息协议'
    }
  },
  {
    path: '/face-policy',
    name: 'FacePolicy',
    component: () => import('@/views/user/user-agents/face-policy/index.vue'),
    meta: {
      title: '四川_众鹤_生物识别协议',
      subTitle: '生物识别协议'
    }
  },
  {
    path: '/user-server',
    name: 'UserServer',
    component: () => import('@/views/user/user-server/index.vue'),
    meta: {
      title: '四川_众鹤_用户服务',
      subTitle: '用户服务'
    }
  },
  {
    path: '/submit-worker',
    name: 'WorkerSubmit',
    component: () => import('@/views/submit/teacher/index.vue'),
    meta: {
      title: '四川_众鹤_职工注册',
      subTitle: '职工注册'
    }
  },
  {
    path: '/auth-user',
    name: 'AuthUser',
    component: () => import('@/views/user/user-server/auth-user/index.vue'),
    meta: {
      title: '四川_众鹤_身份验证',
      subTitle: '身份验证'
    }
  },
  {
    path: '/change-phone',
    name: 'ChangePhone',
    component: () => import('@/views/user/user-server/change-phone/index.vue'),
    meta: {
      title: '四川_众鹤_手机号变更',
      subTitle: '手机号变更'
    }
  },
  {
    path: '/change-phone-result',
    name: 'ChangePhoneResult',
    component: () => import('@/views/user/user-server/result/index.vue'),
    meta: {
      title: '四川_众鹤_修改结果',
      subTitle: '修改结果'
    }
  },
  {
    path: '/submit-result',
    name: 'SubmitResult',
    component: () => import('@/views/submit/result/index.vue'),
    meta: {
      title: '四川_众鹤_注册结果',
      subTitle: '注册结果'
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 解决访问相同路径报错的问题
// 以下两种方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// const routerPush = router.push
// router.push = path => {
//   // 判断下当前路由是否就是要跳转的路由
//   if (router.currentRoute.fullPath.includes(path)) return
//   return routerPush.call(router, path)
// }

export default router;
